/* lystia-quiz.js - квіз «Підбір» (T-E6-12, parity/quiz.md; прототип js/pages/quiz.js mount()).
   Підключення: <script src="{{ 'lystia-quiz.js' | asset_url }}" defer> (snippets/quiz-panel.liquid; повторні підключення ігноруються).
   <lystia-quiz>: чіпи [data-qz-chip][data-q][data-o] (розмітка - серверна), прогрес [data-qz-progress] + .qz-seg, слот результату [data-qz-slot].
   Таблиця підбору (A-044) - JSON у data-table: { effect: { taste: [handle, …] } } або (A-153) { effect: { taste: { teas: [швидко, заварник, гайвань], sets: [набір, запасні…] } } };
   handle'ів у коді немає. Під карткою чаю - рядок набору (.qz-set) з першим наявним sets.
   Результат автоматично після 3-ї відповіді. Картка - Section Rendering: GET <data-products-url><handle>?section_id=<data-section-file> -> [data-qz-frag]
   (кандидати по черзі; перший з data-available="true" виграє, exact = індекс 0; запас -> рядок fallback). Каталогу товарів у JS немає (MUX №9).
   Тексти беруться з data-атрибутів хоста (locales у Liquid), у файлі їх немає.
   A-147: на сторінці квізу (.qz--page) відповіді з URL (?effect=wake&way=pot&taste=dark, лише відомі чіпи) вибираються при завантаженні;
   так короткий квіз зі статті передає першу відповідь.
   Залежності (за наявності): document.lystia (device, reducedMotion), window.LystiaCart.add, document.lystiaToast.show, document.lystiaOverlay (has/open 'cart'). */
(function () {
  'use strict';
  if (window.customElements && customElements.get('lystia-quiz')) return;

  var ORDER = ['effect', 'way', 'taste'];
  /* A-153: відповідь «Як п'єш» обирає чай у клітинці: індекс у teas, решта клітинки - запасні по колу */
  var WAY_INDEX = { fast: 0, pot: 1, gaiwan: 2 };

  function reduced() {
    var c = document.lystia;
    if (c && typeof c.reducedMotion === 'function') return c.reducedMotion();
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function isMobile() {
    var c = document.lystia;
    if (c && typeof c.device === 'function') return c.device() === 'mobile';
    return !(window.matchMedia && window.matchMedia('(min-width: 1024px)').matches);
  }
  function headerH() {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 56;
  }
  function toast(text, opts) {
    if (text && document.lystiaToast && typeof document.lystiaToast.show === 'function') document.lystiaToast.show(text, opts || {});
  }

  class LystiaQuiz extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.ans = {};
      this.shownKey = '';
      this.card = null;
      this.seq = 0;
      this.cache = new Map(); /* handle -> Promise<{el, available}|null> */
      this.chips = {};
      this.groups = {};
      this.table = {};
      try { this.table = JSON.parse(this.getAttribute('data-table') || '{}') || {}; } catch (e) { console.error('[quiz] table', e); }
      this.resultSlot = this.querySelector('[data-qz-slot]');
      this.progText = this.querySelector('[data-qz-progress]');
      this.segs = Array.prototype.slice.call(this.querySelectorAll('.qz-seg'));
      this.checkTpl = this.querySelector('template[data-qz-check]');
      this.base = this.getAttribute('data-products-url') || '/products/';
      this.sectionFile = this.getAttribute('data-section-file') || '';
      ORDER.forEach(function (q) {
        self.chips[q] = {};
        var g = self.querySelector('[data-qz-group="' + q + '"]');
        self.groups[q] = g;
      });
      Array.prototype.forEach.call(this.querySelectorAll('[data-qz-chip]'), function (c) {
        self.chips[c.getAttribute('data-q')][c.getAttribute('data-o')] = c;
      });
      this.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var chip = t.closest('[data-qz-chip]');
        if (chip && self.contains(chip)) { self.choose(chip.getAttribute('data-q'), chip.getAttribute('data-o'), true); return; }
        if (t.closest('[data-qz-retry]')) { self.reset(true); return; }
        var add = t.closest('[data-qz-add]');
        if (add) self.addToCart(add);
      });
      if (this.classList.contains('qz--page')) this.fromUrl();
      this.sync(false);
    }

    /* A-147: попередній вибір з параметрів URL (лише існуючі пари q/o) */
    fromUrl() {
      var self = this, params;
      try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
      ORDER.forEach(function (q) {
        var o = params.get(q);
        if (o && self.chips[q] && self.chips[q][o]) self.ans[q] = o;
      });
    }

    attr(name) { return this.getAttribute(name) || ''; }

    answers() { return Object.assign({}, this.ans); }

    /* set({effect:'wake',way:'fast',taste:'dark'}) - без анімації скролу (API як у прототипі) */
    set(a) {
      var self = this;
      Object.keys(this.ans).forEach(function (k) { delete self.ans[k]; });
      Object.assign(this.ans, a || {});
      this.sync(false);
    }

    reset(scroll) {
      var self = this;
      Object.keys(this.ans).forEach(function (k) { delete self.ans[k]; });
      this.sync(false);
      if (scroll) {
        var top = this.getBoundingClientRect().top + window.pageYOffset - headerH() - 8;
        window.scrollTo({ top: Math.max(0, top), behavior: reduced() ? 'auto' : 'smooth' });
      }
    }

    choose(qid, oid, fromUser) {
      if (this.ans[qid] === oid) delete this.ans[qid]; else this.ans[qid] = oid;
      this.sync(fromUser);
      if (fromUser && this.ans[qid]) {
        var c = this.chips[qid][oid];
        c.classList.remove('is-pop'); void c.offsetWidth; c.classList.add('is-pop');
      }
    }

    sync(fromUser) {
      this.updateChips();
      var n = this.updateProgress();
      if (n === 3) this.showResult(fromUser); else this.hideResult();
      if (n < 3 && this.ans.effect && this.ans.taste) { this.prime(this.candidates()); this.prime(this.setCandidates()); }
    }

    updateChips() {
      var self = this;
      ORDER.forEach(function (q) {
        Object.keys(self.chips[q]).forEach(function (o) {
          var on = self.ans[q] === o;
          var c = self.chips[q][o];
          c.classList.toggle('is-selected', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
    }

    updateProgress() {
      var self = this;
      var n = ORDER.filter(function (q) { return self.ans[q]; }).length;
      this.segs.forEach(function (s, i) { s.classList.toggle('is-on', i < n); });
      var missing = ORDER.filter(function (q) { return !self.ans[q]; }).map(function (q) {
        return self.groups[q] ? self.groups[q].getAttribute('data-short') : '';
      });
      var text;
      if (n === 3) text = this.attr('data-text-done');
      else if (n === 0) text = this.attr('data-text-zero');
      else text = this.attr('data-text-partial').replace('__N__', String(n)).replace('__M__', missing.join(', '));
      if (this.progText) this.progText.textContent = text;
      this.dataset.step = String(n);
      return n;
    }

    /* ---- підбір ---- */
    /* Клітинка таблиці: [handle, …] (стара схема) або { teas: [швидко, заварник, гайвань], sets: [набір, запасні…] } (A-153) */
    cell() { return (this.table[this.ans.effect] || {})[this.ans.taste]; }
    candidates() {
      var row = this.cell();
      if (!row) return [];
      if (Array.isArray(row)) return row.filter(Boolean);
      if (typeof row === 'string') return [row];
      var list = (row.teas || []).filter(Boolean);
      var i = WAY_INDEX[this.ans.way];
      if (list.length > 1 && i) { i = i % list.length; list = list.slice(i).concat(list.slice(0, i)); }
      return list;
    }
    setCandidates() {
      var row = this.cell();
      return row && !Array.isArray(row) && typeof row === 'object' ? (row.sets || []).filter(Boolean) : [];
    }

    /* Фрагмент картки товару: Promise<{el, available}|null>; кеш за handle (повторні запити не йдуть) */
    fragment(handle) {
      if (this.cache.has(handle)) return this.cache.get(handle);
      var url = this.base + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(this.sectionFile);
      var p = fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (res) { if (!res.ok) throw new Error(String(res.status)); return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var frag = doc.querySelector('[data-qz-frag]');
          if (!frag) return null;
          var card = frag.querySelector('.qz-card');
          if (!card) return null;
          Array.prototype.forEach.call(card.querySelectorAll('script, link, style'), function (n) { n.remove(); });
          return { el: card, available: frag.getAttribute('data-available') === 'true' };
        })
        .catch(function (err) { console.error('[quiz] fragment', handle, err); return null; });
      this.cache.set(handle, p);
      return p;
    }

    prime(list) { var self = this; list.forEach(function (h) { self.fragment(h); }); }

    /* -> {card, handle, exact} | null; кандидати по черзі, перший наявний виграє */
    async pick() {
      var list = this.candidates();
      for (var i = 0; i < list.length; i++) {
        var f = await this.fragment(list[i]);
        if (f && f.available) return { frag: f, handle: list[i], exact: i === 0 };
      }
      return null;
    }

    /* A-153: набір під чаєм - перший наявний із sets; null -> рядка немає */
    async pickSet() {
      var list = this.setCandidates();
      for (var i = 0; i < list.length; i++) {
        var f = await this.fragment(list[i]);
        if (f && f.available) return f;
      }
      return null;
    }

    buildSet(f) {
      var src = f.el;
      var link = src.querySelector('.qz-card__title a');
      var img = src.querySelector('.qz-card__photo img');
      var price = src.querySelector('.qz-card__price');
      var add = src.querySelector('[data-qz-add]');
      if (!link) return null;
      var box = document.createElement('div');
      box.className = 'qz-set';
      var label = document.createElement('p');
      label.className = 'qz-set__label';
      label.textContent = this.attr('data-text-set-label');
      var row = document.createElement('div');
      row.className = 'qz-set__row';
      var ph = document.createElement('a');
      ph.className = 'qz-set__photo';
      ph.href = link.getAttribute('href');
      ph.setAttribute('tabindex', '-1');
      ph.setAttribute('aria-hidden', 'true');
      if (img) {
        var im = document.createElement('img');
        im.src = img.getAttribute('src');
        im.alt = '';
        im.width = 112; im.height = 112;
        im.decoding = 'async';
        ph.appendChild(im);
      }
      var info = document.createElement('div');
      info.className = 'qz-set__info';
      var t = document.createElement('a');
      t.className = 'qz-set__title';
      t.href = link.getAttribute('href');
      t.textContent = link.textContent.trim();
      info.appendChild(t);
      if (price) {
        var pr = document.createElement('span');
        pr.className = 'qz-set__price';
        pr.textContent = price.textContent.trim();
        info.appendChild(pr);
      }
      row.appendChild(ph); row.appendChild(info);
      if (add && add.getAttribute('data-variant-id')) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'qz-set__add';
        b.setAttribute('data-qz-add', '');
        b.setAttribute('data-variant-id', add.getAttribute('data-variant-id'));
        b.setAttribute('aria-label', this.attr('data-text-set-add') + ': ' + t.textContent);
        b.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
        row.appendChild(b);
      }
      box.appendChild(label); box.appendChild(row);
      return box;
    }

    whyItems(res) {
      var a = this.ans;
      return [
        this.attr('data-why-effect-' + a.effect),
        this.attr('data-why-way-' + a.way),
        res.exact ? this.attr('data-why-taste-' + a.taste) : this.attr('data-why-fallback'),
      ];
    }

    buildCard(res) {
      var card = res.frag.el.cloneNode(true);
      var ul = card.querySelector('[data-qz-why]');
      var tpl = this.checkTpl;
      if (ul) {
        this.whyItems(res).forEach(function (txt) {
          var li = document.createElement('li');
          var ck = document.createElement('span');
          ck.className = 'qz-card__check';
          ck.setAttribute('aria-hidden', 'true');
          if (tpl) ck.appendChild(tpl.content.cloneNode(true));
          var tx = document.createElement('span');
          tx.textContent = txt;
          li.appendChild(ck); li.appendChild(tx);
          ul.appendChild(li);
        });
      }
      return card;
    }

    async showResult(fromUser) {
      var mySeq = ++this.seq;
      var res = await this.pick();
      if (mySeq !== this.seq) return; /* відповіді змінились під час запиту */
      if (!res) return; /* pick() = null: картка не з'являється, UI помилки нема (Spec §5) */
      var key = res.handle + '|' + this.ans.way + '|' + this.ans.effect + '|' + this.ans.taste;
      if (key === this.shownKey && this.card) return; /* ключ handle|way - як у прототипі (Q-QUIZ-KEY OPEN) */
      this.shownKey = key;
      var fresh = this.buildCard(res);
      var old = this.card;
      this.card = fresh;
      this.classList.add('has-result');
      this.resultSlot.appendChild(fresh);
      if (old) { /* повторний вибір: заміна з кросфейдом */
        old.classList.add('is-leaving');
        setTimeout(function () { old.remove(); }, reduced() ? 0 : 200);
        fresh.classList.add('is-swap');
      } else {
        fresh.classList.add('is-enter');
      }
      requestAnimationFrame(function () { requestAnimationFrame(function () { fresh.classList.add('is-in'); }); });
      this.attachSet(fresh, mySeq);
      if (fromUser && isMobile() && !old) {
        var self = this;
        setTimeout(function () { self.scrollToCard(); }, 60);
      }
    }

    async attachSet(card, mySeq) {
      var f = await this.pickSet();
      if (!f || mySeq !== this.seq || this.card !== card) return;
      var el = this.buildSet(f);
      if (!el) return;
      var retry = card.querySelector('[data-qz-retry]');
      if (retry && retry.parentNode) retry.parentNode.insertBefore(el, retry); else card.appendChild(el);
    }

    hideResult() {
      this.seq++;
      this.shownKey = '';
      this.classList.remove('has-result');
      if (this.card) {
        var c = this.card;
        this.card = null;
        c.classList.add('is-leaving');
        setTimeout(function () { c.remove(); }, reduced() ? 0 : 200);
      }
    }

    scrollToCard() {
      if (!this.card) return;
      var top = this.card.getBoundingClientRect().top + window.pageYOffset - headerH() - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: reduced() ? 'auto' : 'smooth' });
    }

    /* «До кошика»: LystiaCart.add + тост «Додано до кошика» (іконка check) з дією «Кошик» */
    async addToCart(btn) {
      if (btn.classList.contains('is-loading')) return;
      var id = Number(btn.getAttribute('data-variant-id'));
      if (!id) return;
      var self = this;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      try {
        if (!window.LystiaCart) throw new Error('cart');
        await window.LystiaCart.add({ id: id, quantity: 1 });
        toast(this.attr('data-text-added'), {
          icon: 'check',
          action: { label: this.attr('data-text-cart'), onClick: function () {
            var ov = document.lystiaOverlay;
            if (ov && typeof ov.has === 'function' && ov.has('cart')) ov.open('cart');
            else if (self.attr('data-cart-url')) window.location.assign(self.attr('data-cart-url'));
          } },
        });
      } catch (e) {
        toast(this.attr('data-text-failed'), { icon: 'alert' });
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }
  }

  customElements.define('lystia-quiz', LystiaQuiz);
})();
